"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInteger = exports.integerSchema = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const integerSchema = exports.integerSchema = zod.string().transform(val => {
  const parsed = Number.parseInt(val, 10);
  if (Number.isNaN(parsed)) {
    return undefined;
  }
  return parsed;
});

/**
 * Validates the provided string against the integer schema and converts it to integer.
 *
 * @param input - The string to validate.
 * @returns The validated integer if successful, otherwise undefined.
 */
const validateInteger = input => {
  if (input === undefined) {
    return undefined;
  }
  const result = integerSchema.safeParse(input);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
exports.validateInteger = validateInteger;
//# sourceMappingURL=validateInteger.js.map